import {Component, input} from '@angular/core';
import {Divider} from "primeng/divider";
import {RouterLink} from "@angular/router";

export interface AccountPageLink {
  readonly title: string;
  readonly path: string[];
}

@Component({
  selector: 'app-account-page-link',
  standalone: true,
  imports: [
    Divider,
    RouterLink
  ],
  templateUrl: './account-page-link.component.html',
})
export class AccountPageLinkComponent {
  public readonly accountPageLink = input.required<AccountPageLink>();
}
